export enum AuthenticationPlatformAccessOperation {
    create = "b9811845-98ea-4312-be1e-68ba652977dc",
    quickImpersonation = "ef4352f7-ca15-454d-af47-5cb5b17967d7",
    read = "25c6be36-32cd-44ff-b2db-eb17601924cb",
    update = "366c66ef-23b3-4449-a84f-4bb21498a62b",
    delete = "9a0e3a3f-9abe-45bb-b461-a25044ef8b32",
}
